import React from "react";
import { ContactBarContainer, ContactBarBtnLink, MailIcon } from "./contactBarElements";
import { useTranslation } from "react-i18next";

const ContactBarSection = ({ isLight }) => {
  const { t} = useTranslation();
  return (
    <ContactBarContainer isLight={isLight}>
      <ContactBarBtnLink to="/contact">
        <MailIcon />
        {t('navContact.txt')} 
      </ContactBarBtnLink>
    </ContactBarContainer>
  );
};

export default ContactBarSection;
